import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useBooking } from "../../context/BookingContext";
import styles from "./BookingSuccess.module.css";
import useAuthGuard from "../../hooks/useAuthGuard";

const BookingSuccess = () => {
  useAuthGuard();
  const location = useLocation();
  const navigate = useNavigate();
  const { setBookings } = useBooking();

  const message =
    location.state?.message || "Your booking has been successfully confirmed!";
  const bookingType = location.state?.bookingType || "string";
  const userRole = localStorage.getItem("adminRole");

  useEffect(() => {
    setBookings([]);
    localStorage.removeItem("bookings");
  }, [setBookings]);

  const handleNavigation = () => {
    if (
      userRole === "staff" ||
      userRole === "admin" ||
      userRole === "superadmin" ||
      userRole === "stringer"
    ) {
      navigate("/dashboard");
    } else {
      if (bookingType === "grip") {
        navigate("/customer/dashboard/grip-booking-final");
      } else {
        navigate("/customer/dashboard/booking-final");
      }
    }
  };

  return (
    <div className={styles.container}>
      <h2>Booking Successful!</h2>
      <p className={styles.message}>{message}</p>
      <p className={styles.info}>
        You will pay in-store at pickup. Please visit the store to complete your
        transaction.
      </p>
      <button className={styles.backButton} onClick={handleNavigation}>
        Back to Dashboard
      </button>
    </div>
  );
};

export default BookingSuccess;
